import { css } from '@emotion/react';

import { Heading } from '../Heading';
import { useUser, hasChannelSurveyAccess } from '../../providers/UserProvider';
import { ChannelSurveyMapping } from './components/ChannelSurveyMapping';

import { withTransaction } from '@elastic/apm-rum-react';

const channelSurveyUploadContent = css({
  width: '50%',
});

const ChannelSurveyUpload = () => {
  const { roles } = useUser();

  if (!hasChannelSurveyAccess(roles)) {
    return (
      <div>
        You do not have access to the Channel Survey Upload page. This page
        requires both Admin and Revenue Manager permissions. Please contact MCP
        Support.
      </div>
    );
  }

  return (
    <div>
      <Heading type="h1" text="Channel Survey Upload" />
      <div css={channelSurveyUploadContent}>
        <ChannelSurveyMapping />
      </div>
    </div>
  );
};

const ChannelSurveyUploadPage = withTransaction(
  'ChannelSurveyUploadPage',
  'component'
)(ChannelSurveyUpload);

export { ChannelSurveyUploadPage };
